import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRoute from "./components/PrivateRoute";

// Category Pages
import CoreSkills from "./pages/CoreSkills";
import Games from "./pages/Games";
import Recipes from "./pages/Recipes";
import Videos from "./pages/Videos";
import Podcasts from "./pages/Podcasts";
import BodyLanguage from "./pages/BodyLanguage";
import Enrichment from "./pages/Enrichment";
import SAResources from "./pages/SAResources";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/core-skills" element={<PrivateRoute><CoreSkills /></PrivateRoute>} />
        <Route path="/games" element={<PrivateRoute><Games /></PrivateRoute>} />
        <Route path="/recipes" element={<PrivateRoute><Recipes /></PrivateRoute>} />
        <Route path="/videos" element={<PrivateRoute><Videos /></PrivateRoute>} />
        <Route path="/podcasts" element={<PrivateRoute><Podcasts /></PrivateRoute>} />
        <Route path="/body-language" element={<PrivateRoute><BodyLanguage /></PrivateRoute>} />
        <Route path="/enrichment" element={<PrivateRoute><Enrichment /></PrivateRoute>} />
        <Route path="/sa-resources" element={<PrivateRoute><SAResources /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
